'use client';

import React, { useEffect } from "react";
import { LOCATION_MARKER } from "../constants";

const KakaoMap = ({ className }) => {
  useEffect(() => {
    // 브라우저 환경에서만 실행
    if (typeof window !== 'undefined' && window.kakao) {
      const { kakao } = window;

      const container = document.getElementById("map");
      const options = {
        center: new kakao.maps.LatLng(37.476754, 126.983340),
        level: 3,
      };

      const map = new kakao.maps.Map(container, options);

      const imageSrc = LOCATION_MARKER;
      const imageSize = new kakao.maps.Size(98, 69);
      const imageOption = { offset: new kakao.maps.Point(27, 69) };

      const markerPosition = new kakao.maps.LatLng(37.476754, 126.983340);
      const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption);

      const marker = new kakao.maps.Marker({
        position: markerPosition,
        image: markerImage,
      });

      marker.setMap(map);
    }
  }, []);

  return (
      <div
          id="map"
          className={className}
      />
  );
};

export default KakaoMap;
